module.exports = __webpack_public_path__ + "static/img/解决方案-矿山全场景AI视频识别解决方案-全场景多端联动.accc21e1.png";